(function removeBundleVariantOuterBorder() {
  const STYLE_ID = 'bundle-variant-border-removal';
  const BUNDLE_SELECTOR = '.product-bundle-wrapper, .compact-product-bundle';

  function injectStyles() {
    if (document.getElementById(STYLE_ID)) return;

    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      :is(${BUNDLE_SELECTOR}) .product-card__variants .product-form:has(> .variant-picker),
      :is(${BUNDLE_SELECTOR}) .product-card__content .product-card__variants .variant-picker,
      :is(${BUNDLE_SELECTOR}) .product-card__content.text-center .product-card__variants .variant-picker,
      :is(${BUNDLE_SELECTOR}) .product-card__variants .variant-input-wrapper,
      :is(${BUNDLE_SELECTOR}) .product-card__variants fieldset.product-form__input {
        border: none !important;
        border-block-start: none !important;
        outline: none !important;
        box-shadow: none !important;
      }

      :is(${BUNDLE_SELECTOR}) .product-card__variants .variant-input-wrapper .form__label {
        margin-block-end: var(--sp-2d5) !important;
      }

      :is(${BUNDLE_SELECTOR}) .product-card__variants .product-card__bottom {
        margin: 0 !important;
        margin-block-start: var(--sp-1) !important;
      }
    `;
    document.head.appendChild(style);
  }

  function removeInlineBorders(root = document) {
    root.querySelectorAll(`${BUNDLE_SELECTOR} .product-card__variants .variant-picker, ${BUNDLE_SELECTOR} .product-card__variants .product-form, ${BUNDLE_SELECTOR} .product-card__variants .variant-input-wrapper`).forEach((element) => {
      element.style.setProperty('border', 'none', 'important');
      element.style.setProperty('border-block-start', 'none', 'important');
    });
  }

  function init() {
    injectStyles();
    removeInlineBorders();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    init();
    if (event.target) removeInlineBorders(event.target);
  });
})();

if (!customElements.get('compact-product-bundle')) {
  customElements.define(
    'compact-product-bundle',
    class CompactProductBundle extends HTMLElement {
      constructor() {
        super();
    
        this.submitButton.addEventListener('click', this.onSubmitHandler.bind(this));
      }
    
      get variants() {
        return Array.from(this.querySelectorAll('form[is="product-bundle-form"] [name="id"]'));
      }
    
      get submitButton() {
        return this.querySelector('[data-product-bundle-submit]');
      }
    
      get cartDrawer() {
        return document.querySelector('cart-drawer');
      }
    
      onSubmitHandler(event) {
        const data = {
          items: this.variants.map(variant => ({
            id: variant.value,
            quantity: 1
          }))
        };
    
        if (document.body.classList.contains('template-cart') || theme.settings.cartType === 'page') {
          theme.utils.postLink2(theme.routes.cart_add_url, {
            parameters: {
              ...data
            }
          });
          return;
        }
        
        event.preventDefault();
        if (this.submitButton.hasAttribute('aria-disabled')) return;
        this.activeElement = event.submitter || event.currentTarget;
    
        this.handleErrorMessage();
    
        let sectionsToBundle = [];
        document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections: sectionsToBundle } }));
        
        const body = JSON.stringify({
          ...data,
          sections: sectionsToBundle,
          sections_url: window.location.pathname
        });
    
        this.submitButton.setAttribute('aria-disabled', 'true');
        this.submitButton.setAttribute('aria-busy', 'true');
    
        fetch(theme.routes.cart_add_url, { ...theme.utils.fetchConfig('javascript'), body })
          .then((response) => response.json())
          .then(async (parsedState) => {
            if (parsedState.status) {
              this.handleErrorMessage(parsedState.description);
              document.dispatchEvent(new CustomEvent('ajaxProduct:error', {
                detail: {
                  errorMessage: parsedState.description
                }
              }));
              
              const submitButtonText = this.submitButton.querySelector('.btn-text span');
              if (!submitButtonText || !submitButtonText.hasAttribute('data-sold-out')) return;
              submitButtonText.innerText = submitButtonText.getAttribute('data-sold-out');
              this.submitButton.setAttribute('aria-disabled', 'true');
              this.error = true;
              return;
            }
    
            const cartJson = await (await fetch(theme.routes.cart_url, { ...theme.utils.fetchConfig('json', 'GET')})).json();
            cartJson['sections'] = parsedState['sections'];
    
            theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'product-bundle', cart: cartJson });
            document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
              detail: {
                product: parsedState
              }
            }));
    
            this.cartDrawer?.show(this.activeElement);
          })
          .catch((error) => {
            console.log(error);
          })
          .finally(() => {
            this.submitButton.removeAttribute('aria-busy');
    
            if (!this.error) {
              this.submitButton.removeAttribute('aria-disabled');
            }
          });
      }
    
      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;
        
        this.errorMessage = this.errorMessage || this.querySelector('.product-form__error-message');
        if (!this.errorMessage) return;
    
        this.errorMessage.toggleAttribute('hidden', !errorMessage);
        this.errorMessage.innerText = errorMessage;
      }
    }
  );
}
